import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../features/auth/store/authSlice";
import agentChatReducer from "../features/agentChat/store/agentChatSlice";
import documentAgentConversationsReducer from "../features/agentChat/store/documentAgentConversationsSlice";
import genericAgentConversationsReducer from "../features/agentChat/store/genericAgentConversationsSlice";
import conversationMessagesReducer from "../features/agentChat/store/conversationMessagesSlice";
import propertiesReducer from "../features/properties/store/propertiesSlice";
import documentsReducer from "../features/documents/store/documentsSlice";
import documentUploadsReducer from "../features/documentUploads/store/documentUploadsSlice";
import insightsReducer from "../features/insights/store/insightsSlice";

const rootReducer = combineReducers({
  agentChat: agentChatReducer,
  auth: authReducer,
  documentAgentConversations: documentAgentConversationsReducer,
  genericAgentConversations: genericAgentConversationsReducer,
  conversationMessages: conversationMessagesReducer,
  documents: documentsReducer,
  documentUploads: documentUploadsReducer,
  insights: insightsReducer,
  properties: propertiesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
